import React, { useEffect, useState } from "react";
import DateRange from "../../components/DateRange/DateRange";
import { useLocation } from "react-router-dom";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { Table } from "../../components/Table/Table";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import Topbar from "../../components/Topbar/Topbar";
import UserFailedTransaction from "./UserFailedTransaction";
import Select from "react-select";
import {
  ArrowBendUpLeft,
  cancel_icon,
  cashfree_payments_logo,
  Pencil,
  razorpay_logo,
  Search_icon,
} from "../../assets/img";
import { customFilterOption } from "../../components/StaticData";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";

const tabs = ["Not Responded", "Responded"];
const CheckIcon = () => (
  <svg width="11" height="9" viewBox="0 0 11 9" fill="none">
    <path
      d="M1 4L4.2 7.5L10 1"
      stroke="#fff"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const gateways = [
  { id: "razorpay", label: "Razorpay", Logo: razorpay_logo },
  { id: "cashfree", label: "Cashfree", Logo: cashfree_payments_logo },
];

export default function PaymentGateway() {
  const page_size = 200;
  const { paginationData, setpaginationData } = useGlobalContext();
  const [viewPopup, setViewPopup] = useState(false);
  const [addPopup, setAddPopup] = useState(false);
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const [note, setNote] = useState("");
  const [count, setCount] = useState(0);
  const [activeTab, setActiveTab] = useState(
    paginationData?.[path]?.activeTab ?? "Not Responded", // ← reads the passed state
  );
  const [optionsList] = useState([
    { label: "Razor Pay", value: "Razor Pay" },
    { label: "Cash Free", value: "Cash Free" },
  ]);
  const [formData, setFormData] = useState();

  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [transactions, setTransactions] = useState([]);
  const [pagination, setPagination] = useState({});
  const [idSave, setIdSave] = useState(null);

  const [activeGateway, setActiveGateway] = useState("Razor Pay");

  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    status: "",
  });
  const gateways_pay = ["Razor Pay", "Cash Free"];
  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  const parseIconConfig = (icon) => {
    if (!icon) return {};
    try {
      const jsonStart = icon.indexOf("{");
      if (jsonStart === -1) return {};
      return JSON.parse(icon.slice(jsonStart));
    } catch (err) {
      console.error("Failed to parse icon config:", err);
      return {};
    }
  };

  const getListDrop = async () => {
    const res = await get(`${URLS.MASTERURL}by-ids?ids=36,37,46,47`);
    console.log("res?.status", res);
    if (res?.status === "success") {
      const update = res?.data || [];
      setGatewayData(update);

      const newSelected = {
        razorpay: false,
        cashfree: false,
        razorpay_dev: {},
        razorpay_live: {},
        cashfree_dev: {},
        cashfree_live: {},
      };

      update.forEach((item) => {
        switch (item.type) {
          case 36: // razorpay master toggle
            newSelected.razorpay = item.status;
            break;
          case 37: // cashfree master toggle
            newSelected.cashfree = item.status;
            break;
          case 46: {
            // razorpay_test / razorpay_live
            const config = {
              ...parseIconConfig(item.icon),
              status: item.status,
              name: item.name,
            };
            if (item.name === "razorpay_test") {
              newSelected.razorpay_dev = config;
            } else if (item.name === "razorpay_live") {
              newSelected.razorpay_live = config;
            }
            break;
          }
          case 47: {
            // cashfree_sandbox / cashfree_live
            const config = {
              ...parseIconConfig(item.icon),
              status: item.status,
              name: item.name,
            };
            if (item.name === "cashfree_sandbox") {
              newSelected.cashfree_dev = config;
            } else if (item.name === "cashfree_live") {
              newSelected.cashfree_live = config;
            }
            break;
          }
          default:
            break;
        }
      });

      setSelected(newSelected);
    }

    // if (res?.status === "success") {
    //   let update = res?.data;
    //   setGatewayData(update);
    //   const initialSelected = {};
    //   update.forEach((item) => {
    //     initialSelected[item.name] = item.status;
    //   });
    //   setSelected(initialSelected);
    // }
  };

  useEffect(() => {
    getListDrop();
  }, []);

  const getList = async (pageNumber = 1) => {
    const { from, to } = selectedFilter;
    const payload = new FormData();

    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
      payload.append("search", selectedFilter?.search ?? "");
      payload.append("is_read", activeTab === "Responded" ? 1 : 0);
      payload.append("payment_gateway", activeGateway == "Razor Pay" ? 1 : 2);
    }
    payload.append(
      "gateway",
      activeGateway == "Razor Pay" ? "razorpay" : "cashfree",
    );
    if (selectedFilter?.status) {
      payload.append("status", selectedFilter?.status?.value);
    }
    const res = await post(
      `${URLS.PAYMENT_FAILED_LIST}?page=${pageNumber}&page_size=${page_size}`,
      payload,
    );
    console.log("mmc transactions list", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setIdSave(res?.alert_ids?.[0]);
      setTransactions(res?.data);
    }
  };

  useEffect(() => {
    getList(page);

    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], page: page, activeTab: activeTab },
    }));
  }, [page, activeGateway, selectedFilter, activeTab]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "User ID",
        accessor: "user_code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "User Name",
        accessor: "user_name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Mobile Number",
        accessor: "phone_number",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Attempts",
        accessor: "failed_count",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Latest failed Date",
        accessor: "latest_failed_date",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Amount",
        accessor: "latest_failed_amount",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
    ],
    [page],
  );

  const [selected, setSelected] = useState({
    razorpay: false,
    cashfree: false,
    razorpay_dev: {},
    razorpay_live: {},
    cashfree_dev: {},
    cashfree_live: {},
  });

  const [editing, setEditing] = useState(false);
  const [snapshot, setSnapshot] = useState(null);
  // const [activeTab, setActiveTab] = useState("Notifications");
  const handleEdit = () => {
    setSnapshot({ ...selected });
    setEditing(true);
  };

  const handleCancel = () => {
    setSelected(snapshot);
    setEditing(false);
    setSnapshot(null);
  };

  const toggleGateway = (id) => {
    if (!editing) return;
    setSelected((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const [gatewayData, setGatewayData] = useState([]);

  const paymentMethod = async (id, status) => {
    const payload = new FormData();
    payload.append("status", status);
    try {
      const res = await post(`${URLS.MASTERURL}${id}/status/`, payload);
      console.log("paymentMethod res", res);
      getList();
    } catch (err) {
      console.log("ERROR", err);
    }
  };

  const handleSubmit = async () => {
    const updatePromises = gatewayData
      .filter((item) => item.status !== selected[item.name])
      .map((item) => paymentMethod(item.id, selected[item.name]));

    await Promise.all(updatePromises);

    setEditing(false);
    setSnapshot(null);
  };

  const formatOptionLabel = ({ label }) => (
    <div>
      <span>{label}</span>
    </div>
  );

  const markAsRead = async () => {
    if (!note) {
      toast.info("Please add notes");
      return;
    }
    let payload = {
      alert_id: idSave,
      notes: note,
    };
    let res = await post(URLS.PAYMENT_FAILED_MARK_AS_READ, payload);
    console.log("mark as read res", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      setAddPopup(false);
    }
  };

  console.log("seleeeeeee", selected);

  return (
    <div>
      <Topbar header={"Payment Transaction"} />
      <div
        style={{
          padding: "20px 24px",
          background: "#fff",
          borderBottom: "1px solid #e5e7eb",
          flexDirection: "row",
          display: "flex",
          alignItems: "end",
          gap: "40px",
          // justifyContent: "space-between",
        }}
      >
        <div
          style={{
            // borderRight: "1px solid #adadad",
            paddingRight: 17,
            marginRight: 17,
          }}
        >
          <p
            style={{
              margin: "0 0 14px",
              fontSize: 15,
              fontWeight: 600,
              color: "#111",
            }}
          >
            Payment Gateway
          </p>

          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {gateways.map(({ id, Logo }) => {
              return (
                <div
                  key={id}
                  onClick={() => toggleGateway(id)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "8px 14px",
                    borderRadius: 8,
                    border: `1px solid ${
                      !editing
                        ? "#d1d5db"
                        : selected[id]
                          ? "#7F77DD"
                          : "#e5e7eb"
                    }`,
                    background: "#fff",
                    cursor: editing ? "pointer" : "default",
                    userSelect: "none",
                    transition: "border-color 0.15s",
                    height: 69,
                  }}
                >
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      borderRadius: 4,
                      border: `1.5px solid ${
                        !editing
                          ? "#d1d5db"
                          : selected[id]
                            ? "#7F77DD"
                            : "#d1d5db"
                      }`,
                      background: !editing
                        ? "#d1d5db"
                        : selected[id]
                          ? "#7F77DD"
                          : "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      transition: "background 0.15s, border-color 0.15s",
                    }}
                  >
                    {selected[id] && <CheckIcon />}
                  </div>
                  <div style={{ width: 150, height: 90 }}>
                    <img
                      src={Logo}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                </div>
              );
            })}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              {!editing && checkPermission("CAN-EDIT-PAYMENT_GATEWAY") ? (
                <button
                  onClick={handleEdit}
                  className="f2 fs-sm-6 fs-md-8 fs-lg-10 fs-xl-10 fs-xxl-12 white add-btn "
                  // style={{
                  //   padding: "6px 18px",
                  //   borderRadius: 8,
                  //   border: "1px solid #e5e7eb",
                  //   background: "#fff",
                  //   color: "#374151",
                  //   fontSize: 14,
                  //   cursor: "pointer",
                  //   fontWeight: 500,
                  // }}
                >
                  Edit
                </button>
              ) : checkPermission("CAN-EDIT-PAYMENT_GATEWAY") ? (
                <>
                  <button
                    onClick={handleSubmit}
                    style={{
                      padding: "6px 18px",
                      borderRadius: 8,
                      border: "none",
                      background: "#7F77DD",
                      color: "#fff",
                      fontSize: 14,
                      cursor: "pointer",
                      fontWeight: 500,
                    }}
                  >
                    Submit
                  </button>
                  <button
                    onClick={handleCancel}
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: 8,
                      border: "1px solid #e5e7eb",
                      background: "#fff",
                      color: "#6b7280",
                      fontSize: 16,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      lineHeight: 1,
                    }}
                  >
                    ✕
                  </button>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
          }}
        >
          <div style={{ borderRight: "1px solid #adadad", paddingRight: 17 }}>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
              }}
            >
              <p style={{ fontSize: "20px" }}>Razor Pay Dev</p>
              <input
                type="checkbox"
                checked={!!selected?.razorpay_dev?.status}
                readOnly
                disabled={true}
                style={{ width: "20px", height: "25px" }}
              />
            </div>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
              }}
            >
              <p style={{ fontSize: "20px" }}>Razor Pay Live</p>
              <input
                type="checkbox"
                checked={!!selected?.razorpay_live?.status}
                readOnly
                disabled={true}
                style={{ width: "20px", height: "25px" }}
              />
            </div>
          </div>
          <div>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
              }}
            >
              <p style={{ fontSize: "20px" }}>Cashfree Dev</p>
              <input
                type="checkbox"
                checked={!!selected?.cashfree_dev?.status}
                readOnly
                disabled={true}
                style={{ width: "20px", height: "25px" }}
              />
            </div>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
              }}
            >
              <p style={{ fontSize: "20px" }}>Cashfree Live</p>
              <input
                type="checkbox"
                checked={!!selected?.cashfree_live?.status}
                readOnly
                disabled={true}
                style={{ width: "20px", height: "25px" }}
              />
            </div>
          </div>
        </div>
      </div>
      {checkPermission("CAN-VIEW-PAYMENT_GATEWAY") && (
        <>
          <div style={{ display: "flex", marginTop: 20, flexDirection: "row" }}>
            {tabs.map((tab, i) => (
              <>
                {i == 1 && (
                  <span style={{ background: "#D1D1D6", width: 2 }}></span>
                )}
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  style={{
                    padding: "10px 20px",
                    borderRadius: "10px",
                    fontSize: 14,
                    color: activeTab === tab ? "#ffffff" : "#6b7280",
                    background: activeTab === tab ? "#AE55F5" : "none",
                    border: "none",
                    outline: "none",
                    marginLeft: i == 1 ? "10px" : i == 2 ? "10px" : "0px",
                    marginRight: i == 1 ? "10px" : i == 0 ? "10px" : "0px",
                  }}
                >
                  {tab}
                </button>
              </>
            ))}
          </div>
          <div>
            {activeTab === "Not Responded" && (
              <div
                className="mt-3"
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "0 16px 14px",
                  gap: 15,
                }}
              >
                <h1 style={{ fontSize: 22, fontWeight: "bold", margin: 0 }}>
                  {activeGateway === "Razor Pay" ? "Razor Pay" : "Cash Free"}
                </h1>
                {checkPermission("CAN-EDIT-PAYMENT_GATEWAY") && (
                  <button
                    onClick={() => {
                      setActiveGateway("Razor Pay");
                      setPage(1);
                      if (activeTab === "Responded") {
                        setViewPopup(true);
                      } else {
                        setAddPopup(true);
                      }
                    }}
                    style={{
                      padding: "6px 12px",
                      borderRadius: "8px",
                      fontSize: 14,
                      color: "#ffffff",
                      background: "#EF4444",
                      border: "1px solid #EF4444",
                      outline: "none",
                    }}
                  >
                    <img style={{ width: 20, height: 20 }} src={Pencil} />
                    {activeTab === "Responded" ? " View Note" : " Add Note"}
                  </button>
                )}
              </div>
            )}

            <div
              style={{
                padding: "14px 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              <Select
                className="location-search"
                options={optionsList}
                value={
                  optionsList.find((opt) => opt.value === activeGateway) ?? null
                }
                onChange={(opt) => {
                  setActiveGateway(opt?.value ?? "Razor Pay");
                  setPage(1);
                }}
                isClearable
                placeholder={"Razor Pay"}
                formatOptionLabel={formatOptionLabel}
              />

              <div style={{ display: "flex", gap: 8 }}>
                <DateRange
                  // currentDay={true}
                  setFromDate={(date) => {
                    handleChangeFilter("from", date);
                  }}
                  paginationPath={paginationData?.[path]?.[activeTab]}
                  setToDate={(date) => {
                    handleChangeFilter("to", date);
                  }}
                />
              </div>
            </div>

            <div
              style={{
                padding: "0 16px 14px",
                fontSize: 13,
                color: "#374151",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              Total count : <strong>{count}</strong>
            </div>

            {activeTab === "Responded" ? (
              <>
                {(transactions ?? []).map((item, ind) => (
                  <div key={ind}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "0 16px 14px",
                        gap: 15,
                        marginTop: ind === 0 ? 0 : 20,
                      }}
                    >
                      <h1
                        style={{ fontSize: 22, fontWeight: "bold", margin: 0 }}
                      >
                        {activeGateway === "Razor Pay"
                          ? "Razor Pay"
                          : "Cash Free"}
                      </h1>

                      <button
                        onClick={() => {
                          setActiveGateway("Razor Pay");
                          setFormData(item);
                          if (activeTab === "Responded") {
                            setViewPopup(true);
                          } else {
                            setAddPopup(true);
                          }
                        }}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "8px",
                          fontSize: 14,
                          color: "#ffffff",
                          background: "#EF4444",
                          border: "1px solid #EF4444",
                          outline: "none",
                        }}
                      >
                        <img style={{ width: 20, height: 20 }} src={Pencil} />
                        {activeTab === "Responded" ? " View Note" : " Add Note"}
                      </button>
                    </div>

                    <Table
                      columns={columns}
                      setPageno={setPage}
                      pagecount={pagination}
                      data={item?.users || []}
                      show={false}
                      rowsPerPage={page_size}
                    />
                  </div>
                ))}
              </>
            ) : (
              <Table
                columns={columns}
                setPageno={setPage}
                pagecount={pagination}
                data={transactions}
                show={false}
                rowsPerPage={page_size}
              />
            )}
          </div>
        </>
      )}

      {viewPopup && (
        <div
          onClick={() => {
            setFormData(null);
            setViewPopup(false);
          }}
          className="img-popup-design"
        >
          <div onClick={(e) => e.stopPropagation()} className="img-popup">
            <CloseSharpIcon
              onClick={() => {
                setViewPopup(false);
                setFormData(null);
              }}
              className="pointer"
              style={{ selfAlign: "flex-end", width: "190%" }}
            />
            <div className="w-100 mt-3">
              <div className="d-flex mt-3 gap-3">
                <div className="">
                  <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-3 text-start">
                    Admin ID
                  </p>
                  <input
                    className="input-box"
                    name="userName"
                    readOnly
                    type="text"
                    placeholder="Admin ID"
                    value={formData?.approved_by_code}
                    disabled
                  />
                </div>
                <div className="">
                  <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-3 text-start">
                    Issue Noted By
                  </p>
                  <input
                    className="input-box"
                    name="userName"
                    readOnly
                    type="text"
                    placeholder="Slot Regulars"
                    disabled
                    value={formData?.approved_by}
                  />
                </div>
              </div>
              {/* <div className="d-flex mt-3 gap-3"> */}
              <div className="mt-3">
                <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-1 text-start">
                  Issue Noted Date & Time
                </p>
                <input
                  className="input-box"
                  name="timeslot_name"
                  value={formData?.updated_at}
                  readOnly
                  type="text"
                  placeholder="Issue Noted Date & Time"
                  disabled
                />
              </div>

              {/* </div> */}
              <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-3 text-start">
                Description
              </p>
              <textarea
                className="input-box"
                name="description"
                readOnly
                type="text"
                placeholder="Body content of the notification....."
                disabled
                value={formData?.notes}
              />
            </div>
          </div>
        </div>
      )}

      {addPopup && (
        <div onClick={() => setAddPopup(false)} className="img-popup-design">
          <div onClick={(e) => e.stopPropagation()} className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                Note*
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                }}
                className="pointer"
              />
            </div>
            <div
              style={{ justifyContent: "center", width: "100%" }}
              className="d-flex mt-3"
            >
              <textarea
                style={{
                  maxHeight: "80px",
                  background: "#F4F4F4",
                  height: 200,
                  borderRadius: 5,
                  padding: 10,
                }}
                placeholder="Write Here...."
                onChange={(e) => setNote(e.target.value)}
                value={note}
                className="border-0 w-97"
              />
            </div>
            <div className="d-flex ac-je px-2 mt-4">
              <button onClick={markAsRead} className="submit-btn f2 w-100 p-2">
                Add Note
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
